import '@wangeditor/editor/dist/css/style.css'; // 引入 css

import { useState, useEffect } from 'react';
import { message } from 'antd';
import { Editor, Toolbar } from '@wangeditor/editor-for-react';
import request from '@/request';

export default function TextEditor({
  value = '',
  placeholder = '请输入内容...',
  onChange,
  minHeight = 400,
  maxHeight = 1000,
  disabled = false,
}) {
  // editor 实例
  const [editor, setEditor] = useState(null);

  // 编辑器内容
  const [html, setHtml] = useState(value);

  // 同步外部 value 到内部 html
  useEffect(() => {
    setHtml(value);
  }, [value]);

  // 处理编辑器内容变化
  const handleChange = (editor) => {
    let newHtml = editor.getHtml();
    const regex = /blob:https?:\/\/[^"]+/gi;
    newHtml = newHtml.replace(regex, '');
    
    setHtml(newHtml);
    if (onChange) {
      onChange(newHtml);
    }
  };

  // 及时销毁 editor ，重要！
  useEffect(() => {
    return () => {
      if (editor == null) return;
      editor.destroy();
      setEditor(null);
    };
  }, [editor]);

  return (
    <div
      className={`border border-stone-200 rounded-md overflow-hidden max-w-[1200px] ${disabled ? 'opacity-60 cursor-not-allowed pointer-events-none' : ''}`}
    >
      <Toolbar
        editor={editor}
        mode="default"
        style={{ borderBottom: '1px solid #ccc' }}
      />
      <Editor
        defaultConfig={{
          placeholder,
          readOnly: disabled,
          MENU_CONF: {
            uploadImage: {
              /**
               * customUpload：自定义图片上传，使用七牛云存储
               * @param {File} file - 待上传文件
               * @param {Function} insertFn - 编辑器图片插入回调，参数为 (url, alt, href)
               */
              customUpload: async (file, insertFn) => {
                try {
                  const uploadToken = await request.get('/oss/qn/token');
                  const formData = new FormData();
                  formData.append('file', file);
                  formData.append('token', uploadToken);
                  const uploadResponse = await fetch('https://up-z2.qiniup.com', {
                    method: 'POST',
                    body: formData,
                  });
                  if (!uploadResponse.ok) throw new Error('上传失败');
                  const result = await uploadResponse.json();
                  const url = `https://statics.dronex.cc/${result.key}`;
                  insertFn(url, '', url);
                } catch {
                  message.error('图片上传失败');
                }
              },
            },
          },
          /**
           * customPaste：Safari 粘贴图片兼容处理
           * Safari 不走 wangEditor 内置的粘贴上传流程，需手动拦截 clipboardData 中的图片文件并上传
           */
          customPaste: (editor, event) => {
            const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
            if (!isSafari) return true;
            const items = Array.from(event.clipboardData?.items || []);
            const imageItem = items.find((item) => /^image\//.test(item.type));
            if (!imageItem) return true;
            const file = imageItem.getAsFile();
            if (!file) return true;
            (async () => {
              try {
                const uploadToken = await request.get('/oss/qn/token');
                const formData = new FormData();
                formData.append('file', file);
                formData.append('token', uploadToken);
                const uploadResponse = await fetch('https://up-z2.qiniup.com', {
                  method: 'POST',
                  body: formData,
                });
                if (!uploadResponse.ok) throw new Error('上传失败');
                const result = await uploadResponse.json();
                const url = `https://statics.dronex.cc/${result.key}`;
                editor.dangerouslyInsertHtml(`<img src="${url}" alt="">`);
              } catch {
                message.error('图片上传失败');
              }
            })();
            return false;
          },
        }}
        value={html}
        onCreated={setEditor}
        onChange={handleChange}
        mode="default"
        style={{
          minHeight: `${minHeight}px`,
          maxHeight: `${maxHeight}px`,
          overflowY: 'auto',
          textAlign: 'left',
        }}
      />
    </div>
  );
}
